import { render, staticRenderFns } from "./staff-role-manage.vue?vue&type=template&id=a875e180&scoped=true&"
import script from "./staff-role-manage.vue?vue&type=script&lang=js&"
export * from "./staff-role-manage.vue?vue&type=script&lang=js&"
import style0 from "./staff-role-manage.vue?vue&type=style&index=0&id=a875e180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a875e180",
  null
  
)

export default component.exports